import type { VeiculoApto } from './useDadosWizard';

interface Props {
  veiculos: VeiculoApto[];
  idVeiculo: number | null;
  onVeiculo: (v: VeiculoApto) => void;
}

/**
 * Passo 2 — a frota do grupo que realmente emite.
 *
 * A lista é a interseção dos dois cadastros, feita no servidor: veículo que
 * existe só num deles não aparece, porque aceitá-lo trocava uma recusa barata
 * por um CT-e autorizado na SEFAZ que nunca vira ATF.
 *
 * Não é recortada por condutor (ADR-0005 do app derrubou esse filtro) — por
 * isso cada linha nomeia o dono, já que convivem veículos de várias pessoas.
 */
export function PassoVeiculo({ veiculos, idVeiculo, onVeiculo }: Props) {
  return (
    <div className="co-pilha">
      <p className="co-passo-apoio">Frota do grupo inteiro — cada linha diz de quem é.</p>

      {veiculos.length === 0 ? (
        <p className="co-nota co-nota-atencao">Nenhum veículo apto neste grupo. Fale com a cooperativa.</p>
      ) : (
        <fieldset className="co-opcoes">
          <legend className="sr-only">Veículo</legend>
          {veiculos.map(v => (
            <label key={v.idVeiculo} className="co-opcao">
              <input
                type="radio"
                name="veiculo"
                value={v.idVeiculo}
                checked={idVeiculo === v.idVeiculo}
                onChange={() => onVeiculo(v)}
              />
              <span className="co-opcao-marca">{v.placa}</span>
              <span className="co-opcao-texto">
                <span className="co-opcao-titulo">
                  {v.domMarca ? `${v.domMarca} ${v.domModelo ?? ''}`.trim() : 'Veículo'}
                </span>
                <span className="co-opcao-apoio">
                  {v.capacidadePassageiros} lugares
                  {v.nomeMotoristaDono && ` · ${v.nomeMotoristaDono}`}
                </span>
              </span>
            </label>
          ))}
        </fieldset>
      )}
    </div>
  );
}
